import {
  AUTH_LOGOUT_SUCCESS,
  AUTH_REQUEST_OTP_FAILURE,
  AUTH_REQUEST_OTP_REQUEST,
  AUTH_REQUEST_OTP_SUCCESS,
  AUTH_RESET_OTP_ERROR,
  AUTH_SELECT_ACCOUNT,
  AUTH_VERIFY_OTP_FAILURE,
  AUTH_VERIFY_OTP_REQUEST,
  AUTH_VERIFY_OTP_SUCCESS,
  CHECK_BLACK_LIST,
  CHECK_BLACK_LIST_FAILURE,
  CHECK_BLACK_LIST_SUCCESS,
  GET_GLOBAL_CONFIGS_FAILURE,
  GET_GLOBAL_CONFIGS_SUCCESS,
  GET_MST_KEY,
  GET_MST_KEY_FAILURE,
  GET_MST_KEY_SUCCESS,
  GET_PDPA_KEY_FAILURE,
  GET_PDPA_KEY_REQUEST,
  GET_PDPA_KEY_SUCCESS,
  USER_GROUP_POLICIES_FAILURE,
  USER_GROUP_POLICIES_REQUEST,
  USER_GROUP_POLICIES_SUCCESS,
  REGISTER_DEVICE_MFA_SUCCESS,
  REGISTER_DEVICE_MFA_FAILURE,
  GET_PDPA_ORDER_FAILURE,
  GET_PDPA_ORDER_REQUEST,
  GET_PDPA_ORDER_SUCCESS,
  AUTH_SET_UDF_DETAILS,
  AUTH_TOKEN_FAILURE,
  AUTH_TOKEN_SUCCESS,
  AUTH_REGISTER_DEVICE_REQUEST,
  AUTH_TOKEN_REQUEST,
  GET_EMPOWER_USER_DETAILS_REQUEST,
  GET_EMPOWER_USER_DETAILS_SUCCESS,
  GET_EMPOWER_USER_DETAILS_FAILURE,
  SET_EMPOWER_PATH_REDIRECTED,
  GET_STAFF_LOGIN_DETAILS_REQUEST,
  AUTH_SET_UDF_TOKEN_DETAILS,
  GET_WAIVER_LOGIN_DETAILS_FAILURE,
  GET_WAIVER_LOGIN_DETAILS_REQUEST,
  GET_WAIVER_LOGIN_DETAILS_SUCCESS,
  AUTH_CHKBLKLIST_SUCCESS
} from '@/actions/auth/actionTypes';
import TokenService from '@/helpers/tokenService';

export const OTP_CODE = {
  'expired-otp': 'LOGIN_OTP_EXPIRED',
  'invalid-otp': 'LOGIN_OTP_INVALID',
  'too-many-otp-requests': 'LOGIN_OTP_EXCEEDED',
  'too-early-otp-request': 'LOGIN_OTP_TOO_EARLY',
  'login-otp-error': 'LOGIN_OTP_ERROR',
  'blocked-otp-verification': 'LOGIN_OTP_EXCEEDED',
  USER_NOT_REGISTERED: 'LOGIN_USER_NOT_REGISTER',
  401: 'LOGIN_USER_NOT_REGISTER'
};
export enum keygen {
  keyEmpty = ''
}
export const initialState = {
  isPending: false,
  isOTPsent: false, ////unused
  emailId: '',
  clientCode: '',
  privateKey: '',
  otpError: '',
  challengeToken: '',
  accessToken: '',
  refreshToken: '',
  channelToken: '',
  expiryAt: '',
  tokenHeader: [],
  currentAccount: {},
  brnList: [],
  cesList: [],
  userInfo: {},
  isLoggedIn: false,
  retryAfter: 0, ////unused
  customerId: '',
  blackListed: {},
  blackListedError: '',
  isTokenLoading: true,
  isLoading: true,
  configurationList: {},
  globalConfigsList: {},
  isBulkOrder: false,
  orderDetails: {},
  key: keygen.keyEmpty,
  txnType: '',
  userPolicyError: '',
  userPolicy: [],
  check: '',
  empowerData: {
    empowerUserDetail: {},
    loadingUserDetail: false,
    empowerUserDetailError: '',
    empowerUserDetailStatus: '',
    isPathRedirect: false,
  },
  isStaffLogin: false,
  orderFlow: {
    orderType: '',
    encLink: '',
  },
  isRefreshingToken: false,
  pdpaType: ''
};

const getEmpowerUDFData = (action, state) => {
  switch (action.type) {
    case GET_EMPOWER_USER_DETAILS_REQUEST:
      return {
        ...state,
        loadingUserDetail: true,
        empowerUserDetailError: '',
        empowerUserDetailStatus: ''
      }
    case GET_EMPOWER_USER_DETAILS_SUCCESS:
      return {
        ...state,
        empowerUserDetail: action.data,
        loadingUserDetail: false,
        empowerUserDetailStatus: 'SUCCESS'
      }
    case GET_EMPOWER_USER_DETAILS_FAILURE:
      return {
        ...state,
        empowerUserDetail: {},
        loadingUserDetail: false,
        empowerUserDetailError: action.error.response?.data?.message || 'Something went Wrong!!!',
        empowerUserDetailStatus: 'FAILED'
      }

    case SET_EMPOWER_PATH_REDIRECTED:
      return {
        ...state,
        isPathRedirect: action.data
      }

    default:
      return state
  }
}

const getWaiverLoginDetails = (action, state) => {
  const actionType = action.type;
  if (actionType === GET_WAIVER_LOGIN_DETAILS_REQUEST) {
    return {
      ...state,
      isLoading: true
    };
  }
  if (actionType === GET_WAIVER_LOGIN_DETAILS_SUCCESS) {
    const { encLink, ...otherToken } = action.data
    return {
      ...state,
      isLoading: false,
      emailId: action.data.email,
      userInfo: { ...state.userInfo, email: action.data.email },
      ...otherToken,
      orderFlow: {
        ...state.orderFlow,
        orderType: 'WAIVER',
        encLink: encLink
      }
    };
  }
  if (actionType === GET_WAIVER_LOGIN_DETAILS_FAILURE) {
    return {
      ...state,
      isLoading: false,
      accessToken: '',
      refreshToken: '',
      channelToken: '',
      orderFlow: {
        orderType: '',
        encLink: ''
      }
    };
  }
}

const getAuthTokenDetails = (action, state) => {
  const actionType = action.type;
  if (actionType === AUTH_TOKEN_REQUEST) {
    return {
      ...state,
      isTokenLoading: true,
      isLoading: true
    };
  }
  if (actionType === AUTH_TOKEN_SUCCESS || AUTH_TOKEN_FAILURE) {
    return {
      ...state,
      isTokenLoading: false
    };
  }
}

const getPDPAKeyDetails = (action, state) => {
  const actionType = action.type;
  if (actionType === GET_PDPA_KEY_REQUEST) {
    return {
      ...state,
      pdpaType: action.pdpaType,
      isLoading: true
    };
  }
  if (actionType === GET_PDPA_KEY_SUCCESS) {
    const {
      refresh_token_expires_in,
      token_type,
      issued_at,
      client_id,
      access_token,
      scope,
      expires_in,
      refresh_count,
      status
    } = action.data.data;
    return {
      ...state,
      isLoading: false,
      refresh_token_expires_in,
      token_type,
      issued_at,
      client_id,
      access_token,
      scope,
      expires_in,
      refresh_count,
      status,
      emailID: action.data.email,
      key: action.data.encLink.key,
      userInfo: { ...state.userInfo, pdpaEmail: action.data.data.email, token: action.data.data.access_token }
    };
  }
  if (actionType === GET_PDPA_KEY_FAILURE) {
    return {
      ...state,
      isLoading: false,
      accessToken: '',
      refreshToken: ''
      // userInfo: {}
    };
  }
}

const getAuthOtpRequest = (action, state) => {
  const actionType = action.type;
  if (actionType === AUTH_REQUEST_OTP_REQUEST) {
    return {
      ...state,
      isPending: true,
      emailId: ''
    };
  }
  if (actionType === AUTH_REQUEST_OTP_SUCCESS) {
    return {
      ...state,
      isPending: false,
      isOTPsent: true,
      emailId: action.data.email,
      challengeToken: action.data.challengeToken,
      retryAfter: action.data.retryAfter,
      otpError: ''
    };
  }
  if (actionType === AUTH_REQUEST_OTP_FAILURE) {
    return {
      ...state,
      isPending: false,
      isOTPsent: false,
      challengeToken: '',
      retryAfter: 0,
      otpError: OTP_CODE[action.error?.code || action.error?.response?.data?.code] || 'LOGIN_OTP_ERROR'
    };
  }
}

const getMFALoginDetail = (action, state) => {
  switch (action.type) {
    case AUTH_REGISTER_DEVICE_REQUEST:
      return {
        ...state,
        isTokenLoading: true,
        isLoading: true
      };
    // MFA LOGIN REQUESTS
    case REGISTER_DEVICE_MFA_SUCCESS:
      const { clientCode, privateKey } = action.data;
      return {
        ...state,
        isLoading: false,
        clientCode,
        privateKey
      };
    case REGISTER_DEVICE_MFA_FAILURE:
      return {
        ...state,
        clientCode: '',
        privateKey: ''
      };
  }
}

const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_REGISTER_DEVICE_REQUEST:
    case REGISTER_DEVICE_MFA_SUCCESS:
    case REGISTER_DEVICE_MFA_FAILURE:
      return getMFALoginDetail(action, state)

    case AUTH_REQUEST_OTP_REQUEST:
    case AUTH_REQUEST_OTP_SUCCESS:
    case AUTH_REQUEST_OTP_FAILURE:
      return getAuthOtpRequest(action, state)

    case GET_PDPA_ORDER_REQUEST:
    case USER_GROUP_POLICIES_REQUEST:
      return {
        ...state,
        isPending: true
      };
    case AUTH_VERIFY_OTP_REQUEST:
      return {
        ...state,
        isPending: true,
        isLoggedIn: false
      };
    case AUTH_VERIFY_OTP_SUCCESS:
      const {
        accessToken,
        refreshToken,
        brnlist = [],
        ceslist = [],
        name,
        phoneNo,
        email,
        isCmoUser,
        lastname,
        isCESUser,
        isSpocUser
      } = action.data;
      return {
        ...state,
        isPending: false,
        otpError: '',
        accessToken,
        refreshToken,
        brnList: brnlist,
        cesList: ceslist,
        isLoggedIn: true,
        userInfo: { ...state.userInfo, name, lastname, phoneNo, email, isCmoUser, isSpocUser, isCESUser }
      };
    case AUTH_VERIFY_OTP_FAILURE:
      return {
        ...state,
        isPending: false,
        otpError: OTP_CODE[action.error?.code || action.error?.response?.data?.code] || 'LOGIN_OTP_ERROR',
        accessToken: '',
        refreshToken: '',
        brnList: [],
        cesList: [],
        userInfo: {}
      };

    case AUTH_SELECT_ACCOUNT:
      const { account } = action;
      return {
        ...state,
        currentAccount: account,
        isLoggedIn: true,
        isPending: false
      };

    case CHECK_BLACK_LIST:
      return {
        ...state,
        isPending: true,
        blackListedError: '',
        blackListed: {}
      };
    case CHECK_BLACK_LIST_SUCCESS:
      const { data } = action;
      return {
        ...state,
        isPending: false,
        blackListed: data
      };
    case CHECK_BLACK_LIST_FAILURE:
      const { error } = action;
      return {
        ...state,
        isPending: false,
        blackListed: {},
        blackListedError: OTP_CODE[error.response?.data?.code] || 'COMMON_SYSTEM_ERROR'
      };

    case GET_MST_KEY:
      return {
        ...state
      };
    case GET_MST_KEY_SUCCESS:
      return {
        ...state,
        configurationList: action.data
      };
    case GET_MST_KEY_FAILURE:
      return {
        ...state,
        configurationList: {}
      };

    case AUTH_LOGOUT_SUCCESS:
      return initialState;

    case AUTH_RESET_OTP_ERROR:
      return {
        ...state,
        otpError: ''
      };
    case GET_GLOBAL_CONFIGS_SUCCESS:
      return {
        ...state,
        globalConfigsList: action.data
      };
    case GET_GLOBAL_CONFIGS_FAILURE:
      return {
        ...state,
        globalConfigsList: {}
      };

    case AUTH_SET_UDF_DETAILS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          name: action.data.name,
          email: action.data.email,
          isCmoUser: action.data.isCmoUser
        },
        // accessToken: UDFData.accessToken,
        // refreshToken: UDFData.refreshToken,
        emailId: action.data.email
      };

    case AUTH_SET_UDF_TOKEN_DETAILS:
      return {
        ...state,
        accessToken: TokenService.getLocalAccessToken(),
        refreshToken: TokenService.getLocalRefreshToken(),
        channelToken: TokenService.getUDFChannelToken(),
        expiryAt: TokenService.getLocalExpiryAt(),
        tokenHeader: action.data,
      };
    case AUTH_TOKEN_REQUEST:
    case AUTH_TOKEN_SUCCESS:
    case AUTH_TOKEN_FAILURE:
      return getAuthTokenDetails(action, state)

    case GET_PDPA_KEY_REQUEST:
    case GET_PDPA_KEY_SUCCESS:
    case GET_PDPA_KEY_FAILURE:
      return getPDPAKeyDetails(action, state)

    case GET_PDPA_ORDER_SUCCESS:
      return {
        ...state,
        isPending: false,
        isBulkOrder:  !!action.data.data.bulkOrderId,
        orderDetails: action.data.data,
        txnType: action.data.data.txnType,
        currentAccount: { ...state.currentAccount, brn: action.data.data.brn, txnType: action.data.data.txnType },
        userInfo: { ...state.userInfo, brn: action.data.data.brn, orderId: action.data.data.orderId }
      };
    case GET_PDPA_ORDER_FAILURE:
      return {
        ...state,
        orderDetails: {},
        isPending: false
      };
    case USER_GROUP_POLICIES_SUCCESS:
      return {
        ...state,
        isPending: false,
        userPolicy: action.data || [],
        userPolicyError: ''
      };
    case USER_GROUP_POLICIES_FAILURE:
      return {
        ...state,
        isPending: false,
        userPolicy: [],
        userPolicyError: action.error.response?.data?.message
      };
      case AUTH_CHKBLKLIST_SUCCESS:
      return {
        ...state,
        check: action.xPageKey
      };
    case GET_EMPOWER_USER_DETAILS_REQUEST:
    case GET_EMPOWER_USER_DETAILS_SUCCESS:
    case GET_EMPOWER_USER_DETAILS_FAILURE:
    case SET_EMPOWER_PATH_REDIRECTED:
      return {
        ...state,
        empowerData: getEmpowerUDFData(action, state.empowerData)
      }
    case GET_STAFF_LOGIN_DETAILS_REQUEST:
      return {
        ...state,
        isStaffLogin: true
      };
    case GET_WAIVER_LOGIN_DETAILS_REQUEST:
    case GET_WAIVER_LOGIN_DETAILS_SUCCESS:
    case GET_WAIVER_LOGIN_DETAILS_FAILURE:
      return getWaiverLoginDetails(action, state)

    case 'SET_REFRESH_TOKEN_LOADING':
      return {
        ...state,
        isRefreshingToken: action.data
      };
    default:
      return state;
  }
};

export default authReducers;

